export const ENV = 'prod'

export const HOST = (ENV === 'prod') ? 'https://admin.sharyat.com' : 'http://15.207.182.121'
// export const HOST = 'http://localhost:4500'

export const API = '/api/sharyat/admin'

export const isDataModeOn = false

//event section 
export const EVENT_DETAILS = `${HOST}${API}/event/event-details-web-page`